<script>
import { useScrollLock, useToggle } from '@vueuse/core'
import { watch } from 'vue'
import QuickConversation from './quick-conversation.vue'

export default {
  name: 'QuickConversationModal',
  components: { QuickConversation },
  inheritAttrs: false,
  setup (_, { expose }) {
    const [isShow, toggleIsShow] = useToggle(false)
    const isLocked = useScrollLock(document.body)

    const show = () => {
      toggleIsShow(true)
    }

    const hide = () => {
      toggleIsShow(false)
    }

    watch(isShow, isShowNew => {
      isLocked.value = isShowNew
    })

    expose({
      show
    })

    return {
      isShow,
      hide
    }
  }
}
</script>

<template>
  <div
    v-show="isShow"
    class="QuickConversationModal position-fixed inset-0 bg-white"
    tabindex="-1"
  >
    <button
      type="button"
      class="QuickConversationModal__button btn btn-transparent btn-icon btn-sm position-absolute top-0 right-0 mt-2 mr-4"
      @click="hide"
    >
      <i class="fal fa-xmark"></i>
    </button>

    <quick-conversation
      v-bind="$attrs"
    />
  </div>
</template>

<style lang="scss" scoped>
.QuickConversationModal {
  z-index: 100;

  &__button {
    z-index: 101;
  }
}
</style>
